import ExpressionLanguageService from './ExpressionLanguageService';

export default angular.module('edge.platform.el', []).factory('ExpressionLanguageService', ExpressionLanguageService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-exp-lang-angular/module.js
// module id = 300
// module chunks = 0